import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Alert from '@welldev-group/rcl-alert';

const EntityManagementSection = ({
  className,
  outOfLimit,
  title,
  limitText,
  limitAlertText,
  entityListTable,
}) => (
  <div className={classNames('entity-management-section', className)}>
    <div className="entity-management-section__title">{title}</div>
    <div className="entity-management-section__sub-title">{limitText}</div>
    <Alert
      className="entity-management-section__alert"
      isVisible={outOfLimit}
      type="warning"
      hideClose={true}
    >
      <div className="entity-management-section__alert-text">
        {limitAlertText}
      </div>
    </Alert>
    {entityListTable}
  </div>
);

EntityManagementSection.defaultProps = {
  className: '',
  outOfLimit: false,
  title: '',
  limitText: '',
  limitAlertText: '',
  entityListTable: null,
};

EntityManagementSection.propTypes = {
  className: PropTypes.string,
  outOfLimit: PropTypes.bool,
  title: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  limitText: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  limitAlertText: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  entityListTable: PropTypes.node,
};

export default EntityManagementSection;
